import Vue from "vue";
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {postData, getData} from './api.js';
import {uri} from './uri.js';
import * as acName from './action-types';
import * as muName from './mutation-types';
import {myUtil} from './util';
import store from "./store";
import router from "./router";
import axios from 'axios'
import VueDraggableResizable from 'vue-draggable-resizable'
import VueClipboard from 'vue-clipboard2'
import i18n from './i18n/i18n';
// import createPersistedState from 'vuex-persistedstate'

Vue.use(VueClipboard)

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$post = postData
Vue.prototype.$get = getData
Vue.prototype.$uri = uri
Vue.prototype.$axios = axios
Vue.prototype.$filePost = () => {
  return axios.create({
    timeout: 1000,
    headers: {
      "Content-Type": "multipart/form-data",
      "Sec-Fetch-Site": "same-origin",
      ...store.state.userInfo,
    }
  })
}
Vue.prototype.$mutation = muName
Vue.prototype.$action = acName
Vue.prototype.$util = myUtil

Vue.filter("formatDateTime", function(time) {
    if (!time) {
       return ""
    }
  return myUtil.formatDate(new Date(time))
})

Vue.prototype.$formatDate = myUtil.formatDate
Vue.prototype.$isValidUrl = myUtil.isValidURL


Vue.component('vue-draggable-resizable', VueDraggableResizable)


new Vue({
  router,
  store,
    i18n,
  render: h => h(App),

}).$mount("#app");
